<template>
  <CampoRelacionamentoCadastroRapido
    v-model="selecionado"
    :id="name"
    url="cfopsestados"
    cadastro-url="cadastro.CfopEstado"
    :item-text="formatCfopEstado"
    :label="label"
    @change="emit"
  />
</template>

<script>
import CampoRelacionamentoCadastroRapido from "@/components/base/proprios/CampoRelacionamentoCadastroRapido";

export default {
  name: "CampoCfopEstado",
  components: { CampoRelacionamentoCadastroRapido },

  props: {
    label: { type: String, default: "Cfop_estado" },
    payload: { type: Object, required: false },
    name: { type: String, required: true },
  },

  data() {
    return {
      selecionado: {},
    };
  },

  mounted() {
    this.sincronizarPayload();
  },

  watch: {
    payload() {
      this.sincronizarPayload();
    },
  },

  methods: {
    emit() {
      this.$emit("return", this.selecionado);
    },

    sincronizarPayload() {
      if (this.payload) {
        this.selecionado = this.payload;
      }
    },

    formatCfopEstado(item) {
      if (!item) {
        return "";
      }

      const estado = item.estado || {};
      const cfop = item.cfop || {};

      return [estado.nome, cfop.cfop, item.codigoTributacao]
        .filter(Boolean)
        .join(" - ");
    },
  },
};
</script>

<style></style>
